const Call = () => {
  return <>Call Page</>;
};
export default Call;
